<template>
    <div>
        <h2>{{ $t("settings.smart-routing.channel.header") }}</h2>

        <validation-provider #default="{ errors }" name="channel" rules="required">
            <b-form-group
                id="fieldset-channel"
                :description="$t('settings.smart-routing.channel.description')"
                :label="$t('settings.smart-routing.channel.label')"
                :state="errors.length > 0 ? false : null"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="name"
            >
                <b-form-radio-group v-model="currentRoute.channelId" stacked>
                    <b-form-radio v-for="channel in channels" :key="`radio-channel-${channel.id}`" :value="channel.id">
                        <font-awesome-icon :icon="resolvePlatformIcon(channel.provider, channel.platform)" />
                        {{ channel.name }}
                    </b-form-radio>
                </b-form-radio-group>
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>
        <b-form-group
            id="fieldset-identities"
            :description="$t('settings.smart-routing.identities.description')"
            :label="$t('settings.smart-routing.identities.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="name"
        >
            <b-form-tags
                v-model="currentRoute.identities"
                :add-button-text="$t('settings.smart-routing.identities.add')"
                :placeholder="$t('settings.smart-routing.identities.placeholder')"
                :tag-validator="validateIdentity"
                add-button-variant="secondary"
                input-id="tags-basic"
                tag-variant="primary"
            />
        </b-form-group>
    </div>
</template>
<script>
import { BFormGroup, BFormRadioGroup, BFormRadio, BFormTags } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";
import { resolvePlatformIcon } from "@/utils/channels";
import { parsePhoneNumber } from "libphonenumber-js";
import useChannels from "@/composables/v2.1/useChannels";
import useRoutes from "@/views/modules/settings/smart-routing/useRoutes";

export default {
    components: {
        BFormGroup,
        BFormRadio,
        BFormRadioGroup,
        BFormTags,
        ValidationProvider,
    },
    setup() {
        const { channels } = useChannels();
        const { currentRoute } = useRoutes();

        const validateIdentity = (identity) => {
            if (!currentRoute.channelId) {
                return true;
            }

            const channel = channels.find((channel) => channel.id === currentRoute.channelId);

            if (!channel) {
                return true;
            }

            let phoneNumber = undefined;
            try {
                phoneNumber = parsePhoneNumber(identity, "NL");
            } catch {}

            return channel.platform.toLowerCase() !== "whatsapp" || (phoneNumber && phoneNumber.isValid());
        };

        return {
            resolvePlatformIcon,
            channels,
            currentRoute,
            validateIdentity,
        };
    },
};
</script>
